import { render, staticRenderFns } from "./cardApgarFamiliar.vue?vue&type=template&id=075751b6&"
import script from "./cardApgarFamiliar.vue?vue&type=script&lang=js&"
export * from "./cardApgarFamiliar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports